import React from "react";
import {
    capitalizeFirstLetter,
    hasChars,
    hasLowerCase,
    hasNumber, hasUnicodeChars,
    hasUpperCase
} from "../../utils/helpers";
import {formatMessage} from "devextreme/localization";
//import {useAppState} from "../../contexts/app-state";

export default React.memo(({parola, dogrula}) => {
    //const { state } = useAppState();
    const { rules } = window.__APP__.options.password
        // ? window.__APP__.options.password.rules : state.options.password;

    let validations = {
        min : false,
        max : false,
        number : false,
        upper : false,
        lower : false,
        char : false
    }

    let count_enabled = 0;
    let count_validated = 0;

    for (let i = 0; i < rules.length; i++) {
        let rule = rules[i];
        if (rule.enabled) {
            count_enabled++;
            let validated = null;
            switch (rule.type) {
                case 'min':
                    validated = validations.min = parola.length >= rule.vars[1];
                    break;
                case 'max':
                    validated = validations.max = validations.min && parola.length <= rule.vars[1];
                    break;
                case 'number':
                    validated = validations.number = hasNumber(parola);
                    break;
                case 'upper':
                    validated = validations.upper = hasUpperCase(parola);
                    break;
                case 'lower':
                    validated = validations.lower = hasLowerCase(parola);
                    break;
                case 'char':
                    validated = validations.char = hasChars(parola, rule.vars[1]);
                    break;
                case 'unicode':
                    validated = validations.unicode = (parola !== "" && !hasUnicodeChars(parola));
                    break;
                default:
                    validated = false;
                    break;
            }
            if (validated) {
                count_validated ++;
            }
        }
    }

    dogrula(count_enabled === count_validated);

    return <div className="text-left blue-grey-text mb-4 mt-4" style={{fontSize:'0.8rem'}}>
        { rules.map( (e,i) => {
            if (e.enabled === false || e.type === 'max') {
                return null;
            }
            const ok = validations[e.type];
            const msg = capitalizeFirstLetter(formatMessage(e.id, e.vars).trim());
            return <div key={i}>{ok
                ? <i className="fas fa-check-circle" style={{color:"green"}}/>
                : <i className="far fa-circle" />} {msg}
            </div> }
        ) }
    </div>

});
